/**
 * Graphics page entry point. The page is complete without this file -- the wall is
 * server-rendered markup. All that loads here is the theme toggle.
 */

import { initThemeToggle } from '../home/theme-toggle.js';

initThemeToggle(document.querySelector('.theme-toggle'));
